
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/animations/globalAnimationsPanel/globalAnimations.scss.css.virtualfile';
        module.exports = {"animationKitsList":"_animationKitsList_1ny4z_1","animationKitButton":"_animationKitButton_1ny4z_5"};